import jwtDecode from "jwt-decode";

function parseJsonSafely(rawValue) {
  if (!rawValue) return null;
  try {
    return JSON.parse(rawValue);
  } catch (error) {
    return null;
  }
}

export function decodeJwtSafely(token) {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
}

export function getStoredMobileBranchState() {
  if (typeof window === "undefined") {
    return {
      storedHelperBranchId: null,
      storedHelperEmployeeBranchId: null,
      storedEmployeeBranchId: null,
      storedRevxTokenBranchId: null,
    };
  }

  const helperState = parseJsonSafely(localStorage.getItem("eternalHelper"));
  const employeeInfo = parseJsonSafely(localStorage.getItem("eternalEmployeeInfo"));
  const storedRevxToken = localStorage.getItem("revxToken");
  const storedRevxTokenPayload = decodeJwtSafely(storedRevxToken);

  return {
    storedHelperBranchId: helperState?.branchId ?? null,
    storedHelperEmployeeBranchId: helperState?.employeeInfo?.employeeBranchId ?? null,
    storedEmployeeBranchId: employeeInfo?.employeeBranchId ?? null,
    storedRevxTokenBranchId: storedRevxTokenPayload?.branchId ?? null,
  };
}

export function buildMobileBranchDebugContext({
  source,
  token,
  uiBranchId = null,
  brandId = null,
  currentBranchId = null,
  helperBranchId = null,
  extra = {},
} = {}) {
  const tokenPayload = decodeJwtSafely(token);
  const storedState = getStoredMobileBranchState();

  return {
    source: source ?? "unknown",
    brandId,
    uiBranchId,
    currentBranchId,
    helperBranchId,
    tokenBranchId: tokenPayload?.branchId ?? null,
    tokenRoleId: tokenPayload?.roleId ?? null,
    tokenUserId: tokenPayload?.userId ?? null,
    ...storedState,
    ...extra,
  };
}

export function detectMobileBranchMismatch(input) {
  const context = buildMobileBranchDebugContext(input);
  const mismatchReasons = [];

  if (
    context.tokenBranchId != null &&
    context.uiBranchId != null &&
    String(context.tokenBranchId) !== String(context.uiBranchId)
  ) {
    mismatchReasons.push("tokenBranchId!=uiBranchId");
  }

  if (
    context.helperBranchId != null &&
    context.currentBranchId != null &&
    String(context.helperBranchId) !== String(context.currentBranchId)
  ) {
    mismatchReasons.push("helperBranchId!=currentBranchId");
  }

  if (
    context.storedRevxTokenBranchId != null &&
    context.uiBranchId != null &&
    String(context.storedRevxTokenBranchId) !== String(context.uiBranchId)
  ) {
    mismatchReasons.push("storedRevxTokenBranchId!=uiBranchId");
  }

  return {
    hasMismatch: mismatchReasons.length > 0,
    mismatchReasons,
    context,
  };
}

export function getMobileBranchMismatchMessage() {
  return "目前手機分店狀態不同步，請重新切換分店或重新登入後再試。";
}

export function logMobileBranchDebug(label, input, level = "warn") {
  const context = buildMobileBranchDebugContext(input);
  const logFn = typeof console?.[level] === "function" ? console[level] : console.warn;
  logFn(`[mobile-branch-debug] ${label}`, context);
  return context;
}